import e from "react";
import { translate as r } from "@aws-amplify/ui";
import { Flex as t } from "../../../primitives/Flex/Flex.js";
import { Heading as o } from "../../../primitives/Heading/Heading.js";
import { useAuthenticator as n } from "@aws-amplify/ui-react-core";
import { useCustomComponents as i } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as m } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as a } from "../shared/RemoteErrorMessage.js";
import { TwoButtonSubmitFooter as s } from "../shared/TwoButtonSubmitFooter.js";
import { FormFields as l } from "../shared/FormFields.js";
import { RouteContainer as c } from "../RouteContainer/RouteContainer.js";
var u = function u(_ref) {
  var o = _ref.className,
    f = _ref.variation;
  var _n = n(function (e) {
      return [e.isPending];
    }),
    d = _n.isPending,
    _m = m(),
    p = _m.handleChange,
    h = _m.handleSubmit,
    _i = i(),
    _i$components$Confirm = _i.components.ConfirmVerifyUser,
    _i$components$Confirm2 = _i$components$Confirm.Header,
    E = _i$components$Confirm2 === void 0 ? u.Header : _i$components$Confirm2,
    _i$components$Confirm3 = _i$components$Confirm.Footer,
    F = _i$components$Confirm3 === void 0 ? u.Footer : _i$components$Confirm3;
  return e.createElement(c, {
    className: o,
    variation: f
  }, e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmverifyuser": "",
    method: "post",
    onChange: p,
    onSubmit: h
  }, e.createElement(t, {
    as: "fieldset",
    direction: "column",
    isDisabled: d
  }, e.createElement(E, null), e.createElement(t, {
    direction: "column"
  }, e.createElement(l, null)), e.createElement(a, null), e.createElement(s, {
    cancelButtonText: r("Skip"),
    cancelButtonSendType: "SKIP"
  }), e.createElement(F, null))));
};
u.Header = function () {
  return e.createElement(o, {
    level: 3
  }, r("Account recovery requires verified contact information"));
}, u.Footer = function () {
  return null;
};
export { u as ConfirmVerifyUser };